/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-private-classes */
'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UIValidator from '../UIValidator';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { defaultProps, propTypes } from './UIValidatedFormControlPropsInterface';
import messageDefaults from '../constants/messageDefaults';
import WrappedChildInput from '../utils/components/WrappedChildInput';

class UIValidatedFormControl extends Component {
  constructor(...args) {
    super(...args);

    this.getMessage = () => {
      const {
        validationMessage,
        error,
        empty,
        isValidating,
        pristine
      } = this.props;

      if (pristine) {
        return '';
      }

      if (isValidating) {
        return validationMessage.validating;
      }

      if (empty) {
        return validationMessage.empty;
      }

      if (error) {
        return validationMessage.error;
      }

      return validationMessage.success;
    };
  }

  render() {
    const _this$props = this.props,
          {
      children,
      className,
      error,
      trimInputValue,
      validateDefaultValue,
      validateInput
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "empty", "error", "isValidating", "onSuccess", "pristine", "trimInputValue", "validateDefaultValue", "validateInput", "validationMessage", "validationOpts", "validator"]);

    return /*#__PURE__*/_jsx(UIFormControl, Object.assign({}, rest, {
      className: classNames('private-validated-form-control', className),
      error: error,
      validationMessage: this.getMessage(),
      children: /*#__PURE__*/_jsx(WrappedChildInput, {
        onChange: validateInput,
        trimInputValue: trimInputValue,
        validateDefaultValue: validateDefaultValue,
        children: children
      })
    }));
  }

}

UIValidatedFormControl.propTypes = Object.assign({}, propTypes, {
  validateInput: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
  empty: PropTypes.bool.isRequired,
  isValidating: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired
});
UIValidatedFormControl.defaultProps = Object.assign({}, defaultProps, {
  validationMessage: messageDefaults,
  validateDefaultValue: false
});
export default UIValidator(UIValidatedFormControl);